<template>
  <div class="content-wrapper">
    <Loader v-if="!project.name" />
    <section v-if="project.name" class="project-info">
      <h3>{{ $t("project.projectHome.projectName") }}:</h3>
      <p>{{ project.name }}
        <Star position="bottom-right" />
      </p>
      <h3>{{ $t("project.projectHome.projectDescription") }}:</h3>
      <p>{{ project.description }}</p>

      <h3 v-if="!project.enabled" class="error">{{ $t("project.projectHome.infoMsg") }}</h3>

      <div v-for="(module, index) in moduleEnabledList" v-bind:key="index">
        <MegaButton
          v-if="module.moduleEnabled"
          v-bind:title="$t('project.projectHome.button.launch.'+ module.moduleId)"
          v-bind:buttonText="$t('project.projectHome.launchMsg.'+ module.moduleId)"
          v-bind:buttonUrl="analysisUrl + '/' + module.moduleId"
          v-bind:disabled="!project.enabled"
        />
      </div>
    </section>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import MegaButton from '@/components/MegaButton.vue'
import Star from '@/components/Star.vue'

import { projectService } from '@/services/project.service'
import { adminService } from '@/services/admin.service'

export default {
  name: 'ProjectHome',
  components: {
    Loader,
    MegaButton,
    Star
  },
  data () {
    return {
      analysisUrl: '/project/' + this.$route.params.projectId + '/analysis',
      project: {},
      moduleEnabledList: {}
    }
  },
  created: function () {
    this.fetchProject();
  },
  methods: {
    /*fakeData: function () {
      adminService.fakeData(this.$route.params.projectId).then(() => {
        console.log('Fake data created.')
      }).catch(err => {
        console.error('Problems generating fake data: ', err)
      })
    },*/
    fetchProject: function () {
      // grab the project
      return new Promise(async (resolve) => {
        await projectService.getProject(this.$route.params.projectId).then(project => {
          this.project = project
          if(project.description){
              this.project.description = decodeURIComponent(atob(project.description))
          }
        });
        await projectService.getModuleEnabledList(this.$route.params.projectId).then(data => {
          this.moduleEnabledList = data;
        });
        resolve();
      }).catch(err => {
        console.error('something went wrong fetching project: ', err)
      })
    }
  }
}
</script>

<style lang="scss">
.content-wrapper {
  .welcome {
    margin-bottom: 60px;
  }
}

section.group-info {
  margin-bottom: 85px;
}

section.project-info .star {
  font-size: 24px;
  vertical-align: top;
}
</style>
